import { configurePublicApi } from "./client"
import { searchLocation, reverseGeocode } from "./geocoding"
import { planRoute } from "./routes"
import { getStations, getStationDetails, getStopVehicles } from "./stations"
import { getEvents, getEvent } from "./events"
import { createSession } from "./auth"

export const publicApi = {
  configure: configurePublicApi,
  searchLocation,
  reverseGeocode,
  planRoute,
  getStations,
  getStationDetails,
  getStopVehicles,
  getEvents,
  getEvent,
  createSession,
}

export { configurePublicApi, ensureAnonymousSession, publicFetch } from "./client"

export type {
  Location,
  SearchResult,
  RouteStep,
  RouteOption,
  Station,
  StationRoute,
  StationDetails,
  VehiclePosition,
  ContactInfo,
  PublicEvent,
  EventsResponse,
  EventType,
} from "./types"

export {
  EVENT_TYPE_COLORS,
  EVENT_TYPE_LABELS,
  getEventColor,
  getEventLabel,
} from "./types"
